import { z } from "zod";

export const loginSchema = z.object({
  email: z
    .string({ required_error: "Email wajib diisi" })
    .email({ message: "Format email salah" })
    .min(1, { message: "Email wajib diisi" }),
  password: z
    .string({ required_error: "Password wajib diisi" })
    .min(1, { message: "Password wajib diisi" }),
});

export type LoginSchemaType = z.infer<typeof loginSchema>;
